import { useState } from 'react';
import { removeUserFromWorkspace } from '../../../apiServices/userApi';
import { Button } from '../../ui/Button';
import { Spinner } from '../../ui/Spinner';
import { useNotification } from '@/hooks/useNotification';

interface ExitWorkspaceModalProps {
  workspace: { id: { S: string }; title: { S: string } };
  closeModal: () => void;
  currentUserInfo?: { user: { S: string } };
  updateIsQuerying: (q: boolean) => void;
  refreshList: () => void;
}

export default function ExitWorkspaceModal({ workspace, closeModal, currentUserInfo, updateIsQuerying, refreshList }: ExitWorkspaceModalProps) {
  const [loading, setLoading] = useState(false);
  const { notify } = useNotification();

  const exitFromGroup = async () => {
    setLoading(true);
    try {
      updateIsQuerying(true);
      await removeUserFromWorkspace(currentUserInfo!.user.S, workspace.id.S);
      updateIsQuerying(false);
      notify({ type: 'success', message: `Exited from group ${workspace.title.S}` });
      refreshList();
    } catch {
      updateIsQuerying(false);
      notify({ type: 'error', message: `Could not exit from the group '${workspace.title.S}'` });
    }
    setLoading(false);
    closeModal();
  };

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">{`Leave workspace "${workspace.title.S}"?`}</p>
      <Button variant="destructive" onClick={exitFromGroup} disabled={loading}>
        {loading && <Spinner size="sm" />}
        Confirm
      </Button>
    </div>
  );
}
